import { createAction } from 'modules/store'

export const setDrawerIsOpen = createAction<boolean>('ui/setDrawerIsOpen')
